import { DISCOUNT_COUPON_APPLIES_TO } from "../enums/DiscountCouponAppliesToType";
import { DISCOUNT_COUPON_DISCOUNT_TYPE } from "../enums/DiscountCouponDiscountType";
import { DISCOUNT_COUPON_FUNDED_BY } from "../enums/DiscountCouponFundedBy";
import { DISCOUNT_COUPON_REDEMPTION } from "../enums/DiscountCouponRedemptionType";
import { DISCOUNT_COUPON_TYPE } from "../enums/DiscountCouponType";
import { STOCK_TYPES } from "../enums/StockTypes";

export const isRestaurantFund = (fundedBy) =>
  [
    DISCOUNT_COUPON_FUNDED_BY.MIXED,
    DISCOUNT_COUPON_FUNDED_BY.RESTAURANT,
  ].includes(fundedBy);

export const isMorfyFund = (fundedBy) =>
  [DISCOUNT_COUPON_FUNDED_BY.MIXED, DISCOUNT_COUPON_FUNDED_BY.MORFY].includes(
    fundedBy
  );

const DISCOUNT_COUPON_STOCK_NAME = {
  [STOCK_TYPES.LIMITED]: "Limitado",
  [STOCK_TYPES.UNLIMITED]: "Ilimitado",
};

const DISCOUNT_COUPON_FUNDING_NAME = {
  [DISCOUNT_COUPON_FUNDED_BY.MORFY]: "Morfy",
  [DISCOUNT_COUPON_FUNDED_BY.RESTAURANT]: "Restaurante",
  [DISCOUNT_COUPON_FUNDED_BY.MIXED]: "Mixto",
};

const DISCOUNT_COUPON_REDEMPTION_NAME = {
  [DISCOUNT_COUPON_REDEMPTION.NONE]: "Ninguna",
  [DISCOUNT_COUPON_REDEMPTION.FIRST_PURCHASE]: "Primera compra",
};

const DISCOUNT_COUPON_APPLIES_TO_NAME = {
  [DISCOUNT_COUPON_APPLIES_TO.ANY]: "Cualquiera",
  [DISCOUNT_COUPON_APPLIES_TO.PLACE_TYPE]: "Tipo de lugar",
  [DISCOUNT_COUPON_APPLIES_TO.PRODUCT]: "Producto",
  [DISCOUNT_COUPON_APPLIES_TO.RESTAURANT]: "Restaurante",
};

const DISCOUNT_COUPON_DISCOUNT_TYPE_NAME = {
  [DISCOUNT_COUPON_DISCOUNT_TYPE.PERCENTAGE]: "Porcentaje",
  [DISCOUNT_COUPON_DISCOUNT_TYPE.AMOUNT]: "Monto",
};

const DISCOUNT_COUPON_TYPE_NAME = {
  [DISCOUNT_COUPON_TYPE.GLOBAL]: "Global",
  [DISCOUNT_COUPON_TYPE.TARGETED]: "Dirigido",
};

export const DISCOUNT_COUPON_FUNDING_CHOICES = [
  {
    name: DISCOUNT_COUPON_FUNDING_NAME[DISCOUNT_COUPON_FUNDED_BY.MORFY],
    id: DISCOUNT_COUPON_FUNDED_BY.MORFY,
  },
  {
    name: DISCOUNT_COUPON_FUNDING_NAME[DISCOUNT_COUPON_FUNDED_BY.RESTAURANT],
    id: DISCOUNT_COUPON_FUNDED_BY.RESTAURANT,
  },
  {
    name: DISCOUNT_COUPON_FUNDING_NAME[DISCOUNT_COUPON_FUNDED_BY.MIXED],
    id: DISCOUNT_COUPON_FUNDED_BY.MIXED,
  },
];

export const DISCOUNT_COUPON_REDEMPTION_CHOICES = [
  {
    name: DISCOUNT_COUPON_REDEMPTION_NAME[DISCOUNT_COUPON_REDEMPTION.NONE],
    id: DISCOUNT_COUPON_REDEMPTION.NONE,
  },
  {
    name: DISCOUNT_COUPON_REDEMPTION_NAME[
      DISCOUNT_COUPON_REDEMPTION.FIRST_PURCHASE
    ],
    id: DISCOUNT_COUPON_REDEMPTION.FIRST_PURCHASE,
  },
];

export const DISCOUNT_COUPON_APPLIES_TO_CHOICES = [
  {
    name: DISCOUNT_COUPON_APPLIES_TO_NAME[DISCOUNT_COUPON_APPLIES_TO.ANY],
    id: DISCOUNT_COUPON_APPLIES_TO.ANY,
  },
  {
    name: DISCOUNT_COUPON_APPLIES_TO_NAME[
      DISCOUNT_COUPON_APPLIES_TO.PLACE_TYPE
    ],
    id: DISCOUNT_COUPON_APPLIES_TO.PLACE_TYPE,
  },
  {
    name: DISCOUNT_COUPON_APPLIES_TO_NAME[DISCOUNT_COUPON_APPLIES_TO.PRODUCT],
    id: DISCOUNT_COUPON_APPLIES_TO.PRODUCT,
  },
  {
    name: DISCOUNT_COUPON_APPLIES_TO_NAME[
      DISCOUNT_COUPON_APPLIES_TO.RESTAURANT
    ],
    id: DISCOUNT_COUPON_APPLIES_TO.RESTAURANT,
  },
];
export const DISCOUNT_COUPON_DISCOUNT_TYPE_CHOICES = [
  {
    name: DISCOUNT_COUPON_DISCOUNT_TYPE_NAME[
      DISCOUNT_COUPON_DISCOUNT_TYPE.AMOUNT
    ],
    id: DISCOUNT_COUPON_DISCOUNT_TYPE.AMOUNT,
  },
  {
    name: DISCOUNT_COUPON_DISCOUNT_TYPE_NAME[
      DISCOUNT_COUPON_DISCOUNT_TYPE.PERCENTAGE
    ],
    id: DISCOUNT_COUPON_DISCOUNT_TYPE.PERCENTAGE,
  },
];

export const DISCOUNT_COUPON_TYPE_CHOICES = [
  {
    name: DISCOUNT_COUPON_TYPE_NAME[DISCOUNT_COUPON_TYPE.GLOBAL],
    id: DISCOUNT_COUPON_TYPE.GLOBAL,
  },
  {
    name: DISCOUNT_COUPON_TYPE_NAME[DISCOUNT_COUPON_TYPE.TARGETED],
    id: DISCOUNT_COUPON_TYPE.TARGETED,
  },
];

export const DISCOUNT_COUPON_STOCK_TYPE = [
  {
    name: DISCOUNT_COUPON_STOCK_NAME[STOCK_TYPES.LIMITED],
    id: STOCK_TYPES.LIMITED,
  },
  {
    name: DISCOUNT_COUPON_STOCK_NAME[STOCK_TYPES.UNLIMITED],
    id: STOCK_TYPES.UNLIMITED,
  },
];
